module.exports = __webpack_public_path__ + "static/media/997673.c08495cf.jpg";